import { registerService, REGISTER_SEARCH_KEYS } from '@shared/services/register';
import { mapEmpFileToDossierData } from './mapEmpFileToDossierData';

export { mapEmpFileToDossierData };

/** Search inputs order: name → fathersName → surname (matches REGISTER_SEARCH_KEYS). */
export const PERSONAL_FILES_SEARCH_OPTIONS = [
    { key: 'name', label: 'firstName' },
    { key: 'fathersName', label: 'fathersName' },
    { key: 'surname', label: 'surname' },
    { key: 'orgUnitId', label: 'structuralGroup', type: 'orgUnitPicker' },
    { key: 'idn', label: 'idn' },
    { key: 'empId', label: 'employeeNumber' },
];

export { REGISTER_SEARCH_KEYS };

const SORT_KEY_TO_API = {
    number: 'empId',
    name: 'fullName',
    idn: 'idn',
};

function resolveFullName(record) {
    const fullName = record?.fullName ?? record?.name;
    if (!fullName) return '';
    return String(fullName)
        .replace(/\bnull\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function mapRegisterToTableRow(record) {
    return {
        id: record?.id ?? record?.recordId,
        number: record?.empId ?? '',
        name: resolveFullName(record),
        idn: record?.idn ?? '',
        record,
    };
}

function normalizeSortBy(sortBy) {
    if (!sortBy) return sortBy;
    return SORT_KEY_TO_API[sortBy] ?? sortBy;
}

function normalizeRegisterResponse(data, pageSize, pageNumber) {
    const content = Array.isArray(data?.content)
        ? data.content
        : Array.isArray(data)
            ? data
            : [];

    const totalElements = data?.totalElements
        ?? data?.page?.totalElements
        ?? content.length
        ?? 0;

    const totalPages = data?.totalPages
        ?? data?.page?.totalPages
        ?? Math.ceil(totalElements / (pageSize || 10))
        ?? 0;

    const currentPageNumber = data?.pageNumber
        ?? data?.page?.number
        ?? pageNumber
        ?? 0;

    return {
        content: content.map(mapRegisterToTableRow),
        totalElements,
        totalPages,
        pageNumber: currentPageNumber,
    };
}

export const personalFilesService = {
    getRegisterList: async ({
        searchQuery,
        pageNumber = 0,
        pageSize = 10,
        sortBy,
        sortDir,
        ...rest
    } = {}) => {
        const response = await registerService.getRegister({
            page: pageNumber,
            pageSize,
            sortBy: normalizeSortBy(sortBy) || 'empId',
            sortDir: sortDir || 'asc',
            searchQuery,
            ...rest,
        });

        return normalizeRegisterResponse(response, pageSize, pageNumber);
    },

    getEmpFile: async (id) => {
        if (id == null || id === '') {
            throw new Error('Employee file id is required');
        }
        return registerService.getEmpFile(id);
    },

    getDossierData: async (id) => {
        const fileData = await personalFilesService.getEmpFile(id);
        return mapEmpFileToDossierData(fileData);
    },
};
